/**
 * @param namespace
 * @returns {function(Function): Function}
 */
/**
 * @param namespace
 * @returns {function(Function): Function}
 */ export function namespace(namespace) {
    return function namespacedClass(entity) {
        entity.namespace = namespace;
        return entity;
    };
}
/**
 * @param object
 * @returns {string}
 */
export function getNamespacedName(object) {
    let name = typeof object === "function" ? object.name : object.constructor.name;
    if (object.namespace) {
        name = object.namespace + '/' + name;
    }
    if (object.constructor.namespace) {
        name = object.constructor.namespace + '/' + name;
    }
    return name;
}
